import ChatMessageInput from './ChatMessageInputContainer';

export default ChatMessageInput;
